import { usePageSectionData } from '@/components/page-sections/page-section-context';
import { EmptyState } from '@/components/shared/empty-state';
import { type BlogWidgetProps, BlogWidgetVariant } from './definition';
import { CardsVariant } from './variants/cards';
import { GridVariant } from './variants/grid';
import { ListVariant } from './variants/list';

export function BlogWidgetSection() {
  const { props, variant = BlogWidgetVariant.GRID } =
    usePageSectionData<Partial<BlogWidgetProps>>();
  const { title, blogs: rawBlogs } = props;

  const blogs = Array.isArray(rawBlogs) ? rawBlogs : [];

  const hasBlogs = blogs.length > 0;

  if (!hasBlogs) {
    return <EmptyState message="No blogs available. Add blogs to display them here." />;
  }

  switch (variant) {
    case BlogWidgetVariant.LIST:
      return <ListVariant title={title} blogs={blogs} />;
    case BlogWidgetVariant.CARDS:
      return <CardsVariant title={title} blogs={blogs} />;
    default:
      return <GridVariant title={title} blogs={blogs} />;
  }
}
